import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const PaymentSuccessPage: React.FC = () => {
  const { refresh, user } = useAuth();
  const [searchParams] = useSearchParams();
  const [refreshed, setRefreshed] = useState(false);

  useEffect(() => {
    // Aguarda o webhook do MP processar antes de buscar o saldo atualizado
    const timer = setTimeout(async () => {
      await refresh();
      setRefreshed(true);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  const status = searchParams.get('status') || 'approved';

  return (
    <div className="min-h-screen bg-gradient-mystical text-white flex items-center justify-center">
      <div className="text-center max-w-md px-6">
        <div className="text-6xl mb-6">✨</div>
        <h1 className="text-3xl font-bold mb-4">Pagamento confirmado!</h1>
        <p className="text-white/70 mb-2">
          Seus tokens foram creditados na sua conta.
        </p>
        {!refreshed ? (
          <p className="text-purple-300 text-sm mb-8">Atualizando seu saldo...</p>
        ) : (
          <p className="text-green-300 text-sm mb-8">
            Saldo atual: <strong>{user?.tokens_balance ?? '—'} tokens</strong>
          </p>
        )}
        <Link
          to="/dashboard"
          className="inline-block px-8 py-3 bg-gradient-to-r from-gold-500 to-gold-600 text-white rounded-full font-semibold hover:from-gold-600 hover:to-gold-700"
        >
          Ir para o Dashboard
        </Link>
      </div>
    </div>
  );
};

export default PaymentSuccessPage;
